import { emailSignatureApi, emailSignaturePreviewApi } from 'app/services/api';

import { HTTP_RESPONSE_STATUS_CODES } from 'constants/http';
import { catchAsyncActionError } from 'utils/action';
import { getDefaultErrorMessage } from 'utils/axios';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { showErrorMessageAction } from 'store/global/actions';

export const EMAIL_SIGNATURE_ACTION_TYPE = createNamedActions('emailSignature', {
  GET_EMAIL_SIGNATURE: 'GET_EMAIL_SIGNATURE',
  CREATE_EMAIL_SIGNATURE: 'CREATE_EMAIL_SIGNATURE',
  UPDATE_EMAIL_SIGNATURE: 'UPDATE_EMAIL_SIGNATURE',
});

// custom error handling due to 404 when template is absent
export const getEmailSignatureAction = catchAsyncActionError(params => async dispatch => {
  try {
    const { data: responseData } = await emailSignatureApi.getEmailSignature(params);

    return dispatch({
      type: EMAIL_SIGNATURE_ACTION_TYPE.GET_EMAIL_SIGNATURE,
      payload: responseData,
    });
  } catch (err) {
    // case with absent template, no error toast needed
    if (err.response.status === HTTP_RESPONSE_STATUS_CODES.NOT_FOUND) {
      return;
    }

    dispatch(showErrorMessageAction({ message: getDefaultErrorMessage(err), err }));

    return Promise.reject(err);
  }
});

export const getEmailSignaturePreviewAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await emailSignaturePreviewApi.getEmailSignaturePreview(params);

  return dispatch({
    type: EMAIL_SIGNATURE_ACTION_TYPE.GET_EMAIL_SIGNATURE,
    payload: {
      template: {
        value: data,
      },
    },
  });
});

// custom error handling due to 404 when template is absent
export const getApplicationSignaturePreviewAction =
  ({ applicationId }) =>
  async dispatch => {
    try {
      const { data } = await emailSignaturePreviewApi.getApplicationSignaturePreview({
        applicationId,
      });

      return dispatch({
        type: EMAIL_SIGNATURE_ACTION_TYPE.GET_EMAIL_SIGNATURE,
        payload: {
          template: {
            value: data,
          },
        },
      });
    } catch (err) {
      // case with absent template, no error toast needed
      if (err.response.status === HTTP_RESPONSE_STATUS_CODES.NOT_FOUND) {
        return;
      }

      dispatch(showErrorMessageAction({ message: getDefaultErrorMessage(err), err }));

      return Promise.reject(err);
    }
  };

export const createEmailSignatureAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await emailSignatureApi.createEmailSignature(params);

  return dispatch({
    type: EMAIL_SIGNATURE_ACTION_TYPE.CREATE_EMAIL_SIGNATURE,
    payload: data,
  });
});

export const updateEmailSignatureAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await emailSignatureApi.updateEmailSignature(params);

  return dispatch({
    type: EMAIL_SIGNATURE_ACTION_TYPE.UPDATE_EMAIL_SIGNATURE,
    payload: data,
  });
});

export const uploadEmailSignatureFileAction = catchAsyncActionError(
  params => async () => await emailSignatureApi.uploadEmailSignatureFile(params),
);
